/* eslint-disable */
// prettier-ignore

export const messages = {
  system_admin_esg_ratings_overview: "Overview",
};
